var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"billboard px-3 pt-4"},[_c('GenericCarousel',_vm._l((_vm.items),function(item){return _c('a',{key:item.url,attrs:{"href":item.url}},[_c('img',{staticClass:"img-carousel",attrs:{"src":item.image_url}})])}),0)],1)}
var staticRenderFns = []

export { render, staticRenderFns }